import { MutationHookOptions, useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { GAME_TYPES_TYPE } from '../../../constants/constants';

const mutation = gql`
  mutation updateHive($hiveId: String!, $data: HiveUpdateInput!) {
    updateHive(hiveId: $hiveId, data: $data)
  }
`;

export interface HiveUpdateInput {
  name?: string;
  allowedHiveGames?: GAME_TYPES_TYPE[] | null;
}

export interface MutationType {
  updateHive: boolean;
}

export function useUpdateHiveMutation(options?: MutationHookOptions<MutationType>) {
  return useMutation<MutationType>(mutation, {
    ...options,
  });
}
